// EMİR #79 PARÇA C — i18n ALTYAPISI (react-i18next; şimdilik TEK locale = tr).
//
// AMAÇ: arayüz DAVRANIŞI değişmez — TR metinler key'lere taşınır, çıktı BİREBİR aynı
// (piksel-parite). Böylece "bundan sonra yazılan her ekran çeviriye-hazır" olur;
// yeni locale eklemek yalnız bir JSON dosyası eklemektir. Görünür değişiklik SIFIR.
//
// Namespace'ler: common (paylaşılan aksiyonlar) · mycards (kart evreni) · onboarding.
// Kaynaklar INLINE (HTTP backend YOK → offline-deterministik + build-zamanı sabit).
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import trCommon from "./locales/tr/common.json";
import trMycards from "./locales/tr/mycards.json";
import trOnboarding from "./locales/tr/onboarding.json";

export const NS = ["common", "mycards", "onboarding"] as const;

if (!i18n.isInitialized) {
  i18n.use(initReactI18next).init({
    lng: "tr",
    fallbackLng: "tr",
    ns: NS as unknown as string[],
    defaultNS: "common",
    resources: {
      tr: { common: trCommon, mycards: trMycards, onboarding: trOnboarding },
    },
    interpolation: { escapeValue: false }, // React zaten XSS-kaçışı yapar
    returnNull: false,
    react: { useSuspense: false }, // senkron init → Suspense fallback flicker'ı yok
  });
}

export default i18n;
